import { render, staticRenderFns } from "./Mentorship.vue?vue&type=template&id=680eeff5&"
import script from "./Mentorship.vue?vue&type=script&lang=js&"
export * from "./Mentorship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports